import { RootState } from 'sierra-client/state/types'
import { userAdapter } from 'sierra-client/state/users/types'

export const usersSelectors = userAdapter.getSelectors((state: RootState) => state.users.adapter)
